<template>
  <v-row>
    <v-col cols="12">
      <v-card class="progress-status-card mb-2" elevation="1" rounded="xl">
        <v-card-text class="px-6 pb-6">
          <div class="progress-section mb-6">
            <div class="d-flex justify-space-between align-center mb-3">
              <span class="text-body-1 font-weight-medium text-grey-darken-2">
                Status de Preenchimento de itens obrigatórios
              </span>
              <v-chip
                :color="completedPercentage === 100 ? 'success' : 'primary'"
                size="small"
                variant="elevated"
              >
                {{ Math.ceil(completedPercentage) }}%
              </v-chip>
            </div>

            <v-progress-linear
              :value="completedPercentage"
              :color="completedPercentage === 100 ? 'success' : 'primary'"
              bg-color="grey-lighten-4"
              height="16"
              rounded
              class="progress-bar-enhanced"
            >
            </v-progress-linear>
          </div>

          <div class="items-grid pr-2">
            <div v-for="item in filteredExpectedItems" :key="item.value" class="item-row mb-3">
              <v-card
                :color="isFilled(item.value) ? 'success' : 'grey-lighten-5'"
                :variant="isFilled(item.value) ? 'tonal' : 'flat'"
                class="item-card pa-4"
                rounded="lg"
                :ripple="false"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    :color="isFilled(item.value) ? 'green' : 'grey-lighten-3'"
                    size="22"
                    class="mr-4"
                  >
                    <v-icon :color="isFilled(item.value) ? 'white' : 'grey-darken-1'" size="18">
                      {{ isFilled(item.value) ? "mdi-check" : "mdi-circle-outline" }}
                    </v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-1 font-weight-medium mb-1">
                      {{ item.label }}
                    </div>
                    <div
                      class="text-caption d-flex align-center"
                      :class="isFilled(item.value) ? 'text-success' : 'text-grey-darken-1'"
                    >
                      {{ itemSubtitle(item) }}
                    </div>
                  </div>

                  <span
                    v-if="item.count !== undefined"
                    class="text-body-2 font-weight-bold ml-3"
                    :class="isFilled(item.value) ? 'text-success' : 'text-grey-darken-2'"
                  >
                    {{ item.count.current }}/{{ item.count.total }}
                  </span>
                </div>
              </v-card>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "EProgressoPreenchimento",
  props: {
    expectedItems: {
      type: Array,
      required: true, // [{ label: 'Data da Aula', value: 'dataFormatada' }, ...]
    },
    filledItems: {
      type: Array,
      required: true,
    },
    isInfantil: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    filteredExpectedItems() {
      return this.expectedItems.filter((item) => {
        if (item.value === "horarioSelecionado" && this.isInfantil) {
          return false;
        }
        return true;
      });
    },
    completedPercentage() {
      let filled = 0;
      let total = 0;
      this.filteredExpectedItems.forEach((item) => {
        if (item.count !== undefined) {
          filled += item.count.current;
          total += item.count.total;
        } else {
          total += 1;
          if (this.filledItems.includes(item.value)) filled += 1;
        }
      });
      return (filled / (total || 1)) * 100;
    },
    isTotalFilled() {
      return this.filteredExpectedItems.every((item) => this.isFilled(item.value));
    },
  },
  watch: {
    isTotalFilled: {
      handler(newValue) {
        this.$emit("total-filled-changed", newValue);
      },
      immediate: true,
    },
  },
  methods: {
    isFilled(value) {
      const item = this.filteredExpectedItems.find((i) => i.value === value);
      if (item?.count !== undefined) return item.count.current === item.count.total;
      return this.filledItems.includes(value);
    },
    itemSubtitle(item) {
      if (item.count !== undefined) {
        if (item.count.current === item.count.total) return "Preenchido";
        if (item.count.current === 0) return "Falta preencher";
        return `${item.count.current} de ${item.count.total} preenchidos`;
      }
      return this.isFilled(item.value) ? "Preenchido" : "Falta preencher";
    },
  },
};
</script>
<style scoped>
.progress-status-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.progress-bar-enhanced {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 12px !important;
}
.items-grid {
  max-height: 200px;
  overflow-y: auto;
}
.item-card {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(10px);
}
.item-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.item-row {
  animation: fadeInUp 0.3s ease-out forwards;
}
.item-row:nth-child(1) {
  animation-delay: 0.1s;
}
.item-row:nth-child(2) {
  animation-delay: 0.2s;
}
.item-row:nth-child(3) {
  animation-delay: 0.3s;
}
.item-row:nth-child(4) {
  animation-delay: 0.4s;
}
.item-row:nth-child(5) {
  animation-delay: 0.5s;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.progress-section {
  position: relative;
}
.progress-section::before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1), rgba(76, 175, 80, 0.1));
  border-radius: 16px;
  z-index: -1;
  opacity: 0.3;
}
.summary-section {
  position: relative;
}
@media (max-width: 600px) {
  .progress-status-card {
    margin: 8px;
  }
  .item-card {
    margin-bottom: 12px;
  }
}
</style>
